import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// FlatList
import DataTable from 'react-data-table-component';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import LoginForm from '../../components/LoginForm';
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import SearchForm from '../../components/SearchForm';

@inject('AuthStore', 'PaymentNotificationStore')
@observer
class PaymentNotifications extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (Helpers.objectToArray(this.props.PaymentNotificationStore.paymentNotifications.content).length === 0) {
            Helpers.getPaymentNotifications();
        }
    }

    render() {
        const storeId: any = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('payment_notifications')}
                    visibleCategories={false}
                >
                    <section id="breadcrumbs" className="pt-6 bg-gray-50">
                        <div className="container mx-auto px-4 text-xs md:text-base">
                            <ol className="list-reset flex">
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/home`}
                                    >
                                        {Helpers.translation('home')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>{Helpers.translation('payment_notifications')}</li>
                            </ol>
                        </div>
                    </section>

                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto">
                                    <div className="flex flex-col">
                                        <div className="w-full mt-4">
                                            <div className="flex flex-wrap">
                                                <Link to="/paymentnotifications/create">
                                                    <FunctionalButton
                                                        text={Helpers.translation('create')}
                                                        rounded
                                                        customClasses="mb-2"
                                                    />
                                                </Link>
                                            </div>

                                            <SearchForm
                                                inputs={[
                                                    {
                                                        type: "text",
                                                        name: "code",
                                                        placeholder: Helpers.translation('code'),
                                                    },
                                                    {
                                                        type: "dateBetween",
                                                        name: "createdAt",
                                                        placeholder: Helpers.translation('created_at'),
                                                    },
                                                ]}
                                                sendFunction={Helpers.searchPaymentNotifications}
                                                store={this.props.PaymentNotificationStore}
                                                inFilters={[
                                                    `filters[creator_user][changeIndex]=${Helpers.getUserData().id}`,
                                                ]}
                                                autoSend={true}
                                            />

                                            <DataTable
                                                columns={[
                                                    {
                                                        name: Helpers.translation('code'),
                                                        selector: (row: any) => row.code,
                                                    },
                                                    {
                                                        name: Helpers.translation('quantity'),
                                                        selector: (row: any) => row.quantity,
                                                    },
                                                    {
                                                        name: Helpers.translation('currency'),
                                                        selector: (row: any) => row.currency.data.attributes.title,
                                                    },
                                                    {
                                                        name: Helpers.translation('account_number'),
                                                        selector: (row: any) => row.account_number.data.attributes.title,
                                                    },
                                                    {
                                                        name: Helpers.translation('payment_date'),
                                                        selector: (row: any) => Helpers.explodeDate(row.payment_date).date,
                                                    },
                                                    {
                                                        name: Helpers.translation('status'),
                                                        selector: (row: any) => Helpers.translation(row.status),
                                                    },
                                                    {
                                                        name: Helpers.translation('transactions'),
                                                        selector: (row: any) => {
                                                            return (
                                                                <div className="grid grid-cols-2 gap-1">
                                                                    <Link to={`/paymentnotifications/${row.id}`}>
                                                                        <FunctionalButton
                                                                            text={Helpers.translation('details')}
                                                                            rounded
                                                                            customClasses="text-xs"
                                                                        />
                                                                    </Link>
                                                                </div>
                                                            )
                                                        },
                                                    },
                                                ]}
                                                data={
                                                    this.props.PaymentNotificationStore.searchFilterText !== "" ?
                                                        Helpers.objectToArray(this.props.PaymentNotificationStore.searchPaymentNotifications.content).reverse()
                                                        :
                                                        Helpers.objectToArray(this.props.PaymentNotificationStore.paymentNotifications.content).reverse()
                                                }
                                            />

                                            {
                                                this.props.PaymentNotificationStore.searchFilterText !== "" ?
                                                    (Helpers.objectToArray(this.props.PaymentNotificationStore.searchPaymentNotifications.content).length >= 1 && this.props.PaymentNotificationStore.searchPaymentNotifications.page <= this.props.PaymentNotificationStore.searchPaymentNotifications.pageCount) &&
                                                    <div className="w-full flex flex-row justify-center items-center mt-2">
                                                        <FunctionalButton
                                                            onPress={() => Helpers.searchPaymentNotifications()}
                                                            text={Helpers.translation('show-more')}
                                                            rounded
                                                        />
                                                    </div>
                                                    :
                                                    (Helpers.objectToArray(this.props.PaymentNotificationStore.paymentNotifications.content).length >= 1 && this.props.PaymentNotificationStore.paymentNotifications.page <= this.props.PaymentNotificationStore.paymentNotifications.pageCount) &&
                                                    <div className="w-full flex flex-row justify-center items-center mt-2">
                                                        <FunctionalButton
                                                            onPress={() => Helpers.getPaymentNotifications()}
                                                            text={Helpers.translation('show-more')}
                                                            rounded
                                                        />
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <PaymentNotifications {...props} navigate={navigate} />
}

export default WithNavigate;